'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'envelope-dot';
var width = 576;
var height = 512;
var aliases = ["envelope-badge"];
var unicode = 'e16f';
var svgPathData = ['M80 125.4C80 118 86 112 93.4 112L372 112c7.9 30.7 27 57 52.6 74.2L312.2 271.5c-14.3 10.8-34.1 10.8-48.4 0L85.3 136.1c-3.3-2.5-5.3-6.5-5.3-10.7zm0 66.9L234.8 309.8c31.4 23.9 74.9 23.9 106.4 0l136-103.2c6.1 .9 12.4 1.4 18.8 1.4l0 176c0 8.8-7.2 16-16 16L96 400c-8.8 0-16-7.2-16-16l0-191.7z', 'M496 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM93.4 64L369 64c-.7 5.2-1 10.6-1 16 0 11 1.4 21.8 4 32L93.4 112c-7.4 0-13.4 6-13.4 13.4 0 4.2 2 8.2 5.3 10.7L263.8 271.5c14.3 10.8 34.1 10.8 48.4 0l112.4-85.3c15.5 10.4 33.3 17.5 52.6 20.4l-136 103.2c-31.4 23.9-74.9 23.9-106.4 0L80 192.3 80 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-176c17 0 33.2-3.3 48-9.3L544 384c0 35.3-28.7 64-64 64L96 448c-35.3 0-64-28.7-64-64l0-256 .1 0c0-.9-.1-1.7-.1-2.6 0-33.9 27.5-61.4 61.4-61.4z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faEnvelopeDot = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;